import React, { useEffect } from "react"

export function SalarySettings({
  effectiveDate,
  setEffectiveDate,
  salaryType,
  setSalaryType,
  salaryStructure,
  setSalaryStructure,
  ctcAmount,
  setCtcAmount,
}) {

  useEffect(() => {
    setSalaryType("Per Month");
    setSalaryStructure("custom");
  }, []);

   return (
    <div className="w-full md:px-6 py-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-8">
        <div className=" relative space-y-1.5">
          <label className="block text-sm font-medium text-[#3A3541]">
            Effective Date of Change
          </label>
          <input
            type="month"
            value={effectiveDate}
            onChange={(e) =>{
              console.log(e.target.value);
              setEffectiveDate(e.target.value)
            }}
            className="w-full px-3 py-2 bg-white border border-gray-200 rounded-md focus:outline-none text-sm appearance-none font-normal"
          />
          {/* <div className="absolute inset-y-0 top-1/3 right-0 flex items-center px-2 pointer-events-none">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div> */}

        </div>

        <div className="space-y-1.5">
          <label className="block text-sm font-medium text-[#3A3541]">
            Salary Type
          </label>
          <div className="relative">
            <select
              value={salaryType}
              onChange={(e) => setSalaryType(e.target.value)}
              className="w-full px-3 py-2 bg-white border border-gray-200 rounded-md focus:outline-none appearance-none text-sm font-normal"
            >
              <option value="Per Month">Per Month</option>
              <option value="Per Day">Per Day</option>
              <option value="Per Hour">Per Hour</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="block text-sm font-medium text-[#3A3541]">
            Salary Structure
          </label>
          <div className="relative">
            <select
              value={salaryStructure}
              onChange={(e) => setSalaryStructure(e.target.value)}
              className="w-full px-3 py-2 bg-white border border-gray-200 rounded-md focus:outline-none appearance-none text-sm font-normal"
            >
              <option value="custom">Custom</option>
              <option value="breakdown">Salary Box Provided Breakdown</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="block text-sm font-medium text-[#3A3541]">
            CTC Amount
          </label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#3A3541] text-sm">
              ₹
            </span>
            <input
              disabled
              type="text"
              value={ctcAmount}
              onChange={(e) => setCtcAmount(e.target.value)}
              placeholder="10000"
              className="w-full px-3 pl-7 py-2 border border-gray-300 text-[#3A3541] rounded-md focus:outline-none text-sm font-normal disabled:cursor-not-allowed bg-white "
            />
          </div>
        </div>
      </div>
    </div>
  )
}